'use client';

import Link from 'next/link';
import { useLanguage } from '@/context/LanguageContext';

const TERMS_SECTIONS = [
  {
    titleKey: 'serviceTerms.section1.title',
    paragraphKeys: [
      'serviceTerms.section1.clause1',
      'serviceTerms.section1.clause2',
      'serviceTerms.section1.clause3',
    ],
  },
  {
    titleKey: 'serviceTerms.section2.title',
    paragraphKeys: [
      'serviceTerms.section2.clause1',
      'serviceTerms.section2.clause2',
      'serviceTerms.section2.clause3',
    ],
  },
  {
    titleKey: 'serviceTerms.section3.title',
    paragraphKeys: [
      'serviceTerms.section3.clause1',
      'serviceTerms.section3.clause2',
      'serviceTerms.section3.clause3',
    ],
  },
  {
    titleKey: 'serviceTerms.section4.title',
    paragraphKeys: [
      'serviceTerms.section4.clause1',
      'serviceTerms.section4.clause2',
    ],
  },
  {
    titleKey: 'serviceTerms.section5.title',
    paragraphKeys: [
      'serviceTerms.section5.clause1',
      'serviceTerms.section5.clause2',
    ],
  },
  {
    titleKey: 'serviceTerms.section6.title',
    paragraphKeys: [
      'serviceTerms.section6.clause1',
      'serviceTerms.section6.clause2',
    ],
  },
  {
    titleKey: 'serviceTerms.section7.title',
    paragraphKeys: ['serviceTerms.section7.clause1'],
  },
  {
    titleKey: 'serviceTerms.section8.title',
    paragraphKeys: ['serviceTerms.section8.clause1'],
  },
  {
    titleKey: 'serviceTerms.section9.title',
    paragraphKeys: ['serviceTerms.section9.clause1'],
  },
];

export default function TermsOfServicePage() {
  const { t } = useLanguage();

  return (
    <main className="min-h-screen bg-[#0a0a0f] px-4 py-6 text-white sm:px-6 sm:py-8 lg:px-8">
      <div className="mx-auto max-w-4xl">
        <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-5 sm:p-7">
          <p className="text-[10px] uppercase tracking-[0.24em] text-brand-300">GreenPro</p>
          <h1 className="mt-2 text-2xl font-black leading-tight sm:text-3xl">{t('serviceTerms.title')}</h1>
          <p className="mt-3 text-sm text-[hsl(var(--muted-foreground))]">{t('serviceTerms.lastUpdated')}</p>
          <p className="mt-4 text-sm leading-relaxed text-zinc-300 sm:text-[15px]">{t('serviceTerms.intro')}</p>
        </div>

        <section className="mt-5 space-y-3 rounded-2xl border border-white/10 bg-white/[0.02] p-4 sm:p-6">
          {TERMS_SECTIONS.map((section) => (
            <article key={section.titleKey} className="rounded-xl border border-white/8 bg-black/10 p-4 sm:p-5">
              <h2 className="text-sm font-semibold text-white sm:text-base">{t(section.titleKey)}</h2>
              <div className="mt-3 space-y-2 text-xs leading-relaxed text-[hsl(var(--muted-foreground))] sm:text-sm">
                {section.paragraphKeys.map((paragraphKey) => (
                  <p key={paragraphKey}>{t(paragraphKey)}</p>
                ))}
              </div>
            </article>
          ))}
        </section>

        <div className="mt-6">
          <Link
            href="/login"
            className="inline-flex items-center rounded-lg border border-white/15 bg-white/[0.04] px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-white/[0.08]"
          >
            {t('legal.backToLogin')}
          </Link>
        </div>
      </div>
    </main>
  );
}
